<template>
  <CBreadcrumb class="me-auto mb-0">
    <CBreadcrumbItem v-for="item in breadcrumbs" :key="item" :href="item.active || item.block_link ? '' : item.path"
      :active="item.active">
      {{ item.name }}
    </CBreadcrumbItem>
  </CBreadcrumb>
</template>

<script>
import { onMounted, ref } from 'vue'
import router from '@/router'

export default {
  name: 'AppBreadcrumb',
  setup() {
    const breadcrumbs = ref()

    const getBreadcrumbs = () => {
      // Records ohne Namen tragen nichts zum Pfad bei, ebenso wenig der
      // Index-Child einer Routen-Gruppe: er steht fuer dieselbe Seite wie die
      // Gruppe und traegt den Namen nur, damit der Router nicht warnt. Aktiv
      // ist der letzte verbleibende Record - ein Pfadvergleich scheitert bei
      // Params (:id) und Query-Strings.
      const matched = router.currentRoute.value.matched.filter(
        (route) => route.name && !route.meta?.hideInBreadcrumb,
      )
      return matched.map((route) => {
        return {
          active: route === matched[matched.length - 1],
          name: route.name,
          path: `${router.options.history.base}${route.path}`,
          block_link:
            route.beforeEnter === undefined && route.redirect != '/dashboard',
        }
      })
    }

    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return {
      breadcrumbs,
    }
  },
}
</script>